import classNames from "classnames";

import styles from "./ListRow.module.scss";

// components
import Chip from "../Chip/Chip";

// icons
import { ReactComponent as ArrowRight } from "../../assets/icons/chevron_right.svg";
import { ReactComponent as Checklist } from "../../assets/icons/checklist.svg";

const ListRow = ({ firstName, lastName, img, attended, all, val }) => {
  const handleSelectRange = () => {};
  return (
    <div className={styles.listRow}>
      <div className={styles.initials}>
        <Chip {...{ img, lastName, firstName }} />
        <span className={styles.fullName}>
          {firstName} {lastName}
        </span>
      </div>
      <div>
        <Checklist />
        <span
          className={classNames([
            styles.attending,
            val === "least" ? styles.least : styles.most,
          ])}
        >
          {attended + "/" + all}
        </span>
      </div>
      {/* <ArrowRight /> */}
      <div></div>
    </div>
  );
};

export default ListRow;
